<script>
		import { createEventDispatcher } from 'svelte';
    import MdcUtils from './MdcUtils';

const dispatch = createEventDispatcher();
export let account;

function reloadAccount() {
		dispatch('action', {do: 'doSelectAccount', account});
}

</script>
{#if account}
<div>
	<h6>{account.title || 'Account created on ' + new Date(account.acct?.ts||Date.now()).toLocaleDateString()}</h6>
	<h3><b>{MdcUtils.format(account.avail)}</b> available balance</h3>
	</div>

<div class="modal panel">

	<div class="account-actions">
		<button on:click={() => alert('Coming soon!')}>Transfer</button>
		<button on:click={() => alert('Coming soon!')}>Send</button>
		<button on:click={() => dispatch('action',{do:'doLeaveCashBegin', account})}>Leave Cash</button>
		<button on:click={() => dispatch('action', {do:'doSelectAccount',account: null })}>Close</button>
	</div>

	<!-- for each details.trxs as trx display the transaction-->
	{#if account.trxs && !account.loading}
	<div id ="transactions" class="mt-2-333">
	<!-- Date selectors. The default is for the last 30 days -->
<div class="date-selectors">
	<div class="date-selector">
		<label for="start-date">Start Date</label>
		<input type="date" id="start-date" name="start-date" bind:value={account.start} on:change={reloadAccount}>
	</div>
	<div class="date-selector">
		<label for="end-date">End Date</label>
		<input type="date" id="end-date" name="end-date" bind:value={account.end} on:change={reloadAccount}>
	</div>
	<div class="num-selector">
		<!-- dropdown box with the option 25, 100, 250 -->
		<label for="num-txs"># rows</label>
		<select id="num-txs" name="num-transactions" bind:value={account.num} on:change={reloadAccount}>
			<option value="25">25</option>
			<option value="100">100</option>
			<option value="250">250</option>
		</select>
		</div>

		<!-- div to download-->
		<div class="download icon-download clickable" on:click={() => {account.download=true; reloadAccount() } } title="download">
</div>
</div>

	{#each account.trxs??[] as trx}
		<div class="transaction" style="padding:.333em;" >
			<div class="spread">
				<div class="transaction-amount">
				<b>{trx.amt>0?'+':''}{Intl.NumberFormat().format(Math.floor(trx.amt)) }</b>
				</div>
				<div class="transaction-date" style="padding-left:2em;padding-right:2em;">
					{new Date(trx.ts).toLocaleDateString()}	{new Date(trx.ts).toLocaleTimeString()}
				</div>
				<div class="transaction-balance">
					<b>Balance: {MdcUtils.format(trx.bal)}</b><br>
					<span title="Tax {trx.tax??0}" style="padding-right:.666em;">Tax: {parseFloat(trx.tax?? 0).toFixed(3) + '...'} </span>
					<span title="Timed deposit">Dep: {trx.dep ?? 0}</span>
				</div>
			</div>
			<div class="transaction-description" style="align:right;">
				{#if trx.mode=='cash'}
				<div style="display:inline-block;" class="clickable" on:click={() => dispatch('action', { do:'doShare', txId:trx.id} )}>💵</div>
				{/if}
		{trx.msg}
			</div>
		</div>
	{/each}
</div>

	{:else}
		<div class="loading">
			Loading...
		</div>
	{/if}


	</div>

	{/if}
<style>


	
</style>